import FilterSlider from './FilterSliderContainer';
import { percentToIn } from './FilterSlider'

export const INCHES10 = '10';
export const INCHES2 = '2';
export const INCHES6 = '6';
export const MPH50 = '50';
export { percentToIn }

export default FilterSlider

